module.exports = __webpack_public_path__ + "media/images/lps-secondcarrier-11bbb2ed.png";